export const duesAttendanceEn = {
  'error.billing.annualDuesExists':
    'This account already has dues for this year. Correct posted charges with credits or reversals.',
  'billing.annual.title': 'Yearly membership fee',
  'billing.annual.help':
    'Set the total fee for this payer account and calendar year. Choose one payment or 12 monthly installments. Use either this schedule or recurring fee assignments for the same dues.',
  'billing.annual.year': 'Year',
  'billing.annual.amount': 'Yearly fee',
  'billing.annual.credited': 'Credits and reversals',
  'billing.annual.paid': 'Paid toward this year',
  'billing.annual.remaining': 'Left to pay',
  'billing.annual.installments': 'Payment schedule',
  'billing.annual.once': 'One annual charge',
  'billing.annual.monthly': '12 monthly installments',
  'billing.annual.dueMonth': 'Due month (1–12)',
  'billing.annual.preview': 'Preview yearly fee',
  'billing.annual.confirm': 'Post yearly fee',
  'billing.annual.confirmHelp':
    'Review the due dates and amounts. Posting creates the whole yearly obligation, including future installments. Later corrections use credits or reversals.',
  'billing.annual.saved': 'The yearly fee was posted.',
  'billing.annual.empty': 'No yearly fee has been set for this account and year.',
  'billing.annual.payments': 'Payments toward this yearly fee',
  'billing.annual.applied': 'Applied to this year',
  'billing.annual.paymentHelp':
    'Record payments below and confirm their allocation to the charges. Unallocated credit does not reduce the amount left to pay until it is allocated.',
  'calendar.history.title': 'Who was present or absent, and when',
  'calendar.history.help':
    'Use the calendar date range above. Actual attendance is separate from RSVP; unrecorded attendance does not mean absent. Draft and cancelled events are excluded.',
  'calendar.history.allAthletes': 'All athletes',
  'calendar.history.allStatuses': 'All attendance statuses',
  'calendar.history.status': 'Attendance status',
  'calendar.history.show': 'Show attendance history',
  'calendar.history.openEvent': 'Open event and attendance',
  'billing.annualFees.title': 'Yearly fees by team',
  'billing.annualFees.description':
    'Set the yearly fee of each age group and see what every account has paid and has left to pay.',
  'billing.annualFees.help':
    'Set one yearly fee per age group and calendar year. Each account owes the fee of every athlete on it, by the team the athlete is on at the start of the year (or the first team joined during it). All payments dated in that year are subtracted, net of refunds, whether or not they are allocated to a charge. Nothing is posted here.',
  'billing.annualFees.rates': 'Yearly fee per age group',
  'billing.annualFees.notSet': 'Not set',
  'billing.annualFees.save': 'Save',
  'billing.annualFees.saved': 'The yearly fee was saved.',
  'billing.annualFees.overview': 'Paid and left to pay',
  'billing.annualFees.team': 'Team',
  'billing.annualFees.allTeams': 'All teams',
  'billing.annualFees.noTeam': 'No team',
  'billing.annualFees.onlyOpen': 'Only accounts with an amount left to pay',
  'billing.annualFees.paid': 'Paid in this year',
  'billing.annualFees.overpaid': 'Paid in excess',
  'billing.annualFees.incomplete':
    'The fee is incomplete: an athlete has no team or there is no yearly fee for their age group.',
  'billing.annualFees.noAthlete': 'No athlete is on this account in this year.',
  'billing.annualFees.empty': 'No account has athletes or payments in this year.',
  'billing.annualFees.shown': 'Accounts shown',
} as const;

export const duesAttendanceHu: Record<keyof typeof duesAttendanceEn, string> = {
  'error.billing.annualDuesExists':
    'Ehhez a számlához erre az évre már tartozik tagdíj. A könyvelt tételeket jóváírással vagy sztornóval javíthatja.',
  'billing.annual.title': 'Éves tagdíj',
  'billing.annual.help':
    'Állítsa be a fizető számlájának teljes naptári éves tagdíját, egy összegben vagy 12 havi részletben. Ugyanarra a tagdíjra vagy ezt az ütemezést, vagy az ismétlődő díjhozzárendelést használja.',
  'billing.annual.year': 'Év',
  'billing.annual.amount': 'Éves tagdíj',
  'billing.annual.credited': 'Jóváírások és sztornók',
  'billing.annual.paid': 'Erre az évre befizetve',
  'billing.annual.remaining': 'Hátralévő fizetendő összeg',
  'billing.annual.installments': 'Fizetési ütemezés',
  'billing.annual.once': 'Egy éves díjtétel',
  'billing.annual.monthly': '12 havi részlet',
  'billing.annual.dueMonth': 'Esedékesség hónapja (1–12)',
  'billing.annual.preview': 'Éves tagdíj előnézete',
  'billing.annual.confirm': 'Éves tagdíj könyvelése',
  'billing.annual.confirmHelp':
    'Ellenőrizze az esedékességeket és az összegeket. A könyvelés a teljes éves kötelezettséget létrehozza, a jövőbeli részletekkel együtt. A későbbi javítások jóváírással vagy sztornóval történnek.',
  'billing.annual.saved': 'Az éves tagdíj könyvelve.',
  'billing.annual.empty': 'Ehhez a számlához erre az évre még nincs éves tagdíj beállítva.',
  'billing.annual.payments': 'Az éves tagdíjra történt befizetések',
  'billing.annual.applied': 'Erre az évre elszámolva',
  'billing.annual.paymentHelp':
    'Rögzítse alább a befizetéseket, és erősítse meg a díjtételekre való elszámolásukat. A még el nem számolt jóváírás az elszámolásig nem csökkenti a hátralékot.',
  'calendar.history.title': 'Ki, mikor volt jelen vagy hiányzott',
  'calendar.history.help':
    'Használja a fenti naptári dátumtartományt. A tényleges jelenlét különbözik a részvételi választól; a nem rögzített jelenlét nem jelent hiányzást. A piszkozat és a lemondott események kimaradnak.',
  'calendar.history.allAthletes': 'Minden sportoló',
  'calendar.history.allStatuses': 'Minden jelenléti állapot',
  'calendar.history.status': 'Jelenléti állapot',
  'calendar.history.show': 'Jelenléti előzmények megjelenítése',
  'calendar.history.openEvent': 'Esemény és jelenlét megnyitása',
  'billing.annualFees.title': 'Éves tagdíj csapatonként',
  'billing.annualFees.description':
    'Állítsa be korosztályonként az éves tagdíjat, és nézze meg, mennyit fizetett és mennyi van még hátra az egyes számlákon.',
  'billing.annualFees.help':
    'Korosztályonként és naptári évenként egy éves tagdíjat állíthat be. Minden számla a rajta lévő sportolók tagdíjával tartozik, annak a csapatnak a korosztálya szerint, amelyben a sportoló az év elején van (vagy amelyhez az év során először csatlakozott). Az adott évre dátumozott összes befizetés levonódik a visszatérítések nélkül, akár el van számolva díjtételre, akár nincs. Itt semmi nem kerül könyvelésre.',
  'billing.annualFees.rates': 'Éves tagdíj korosztályonként',
  'billing.annualFees.notSet': 'Nincs beállítva',
  'billing.annualFees.save': 'Mentés',
  'billing.annualFees.saved': 'Az éves tagdíj elmentve.',
  'billing.annualFees.overview': 'Befizetve és hátralévő',
  'billing.annualFees.team': 'Csapat',
  'billing.annualFees.allTeams': 'Minden csapat',
  'billing.annualFees.noTeam': 'Nincs csapat',
  'billing.annualFees.onlyOpen': 'Csak a hátralékos számlák',
  'billing.annualFees.paid': 'Ebben az évben befizetve',
  'billing.annualFees.overpaid': 'Túlfizetés',
  'billing.annualFees.incomplete':
    'A tagdíj hiányos: egy sportoló nincs csapatban, vagy a korosztályához nincs éves tagdíj beállítva.',
  'billing.annualFees.noAthlete': 'Ezen a számlán ebben az évben nincs sportoló.',
  'billing.annualFees.empty': 'Ebben az évben egy számlán sincs sportoló vagy befizetés.',
  'billing.annualFees.shown': 'Megjelenített számlák',
};

export const duesAttendanceRo: Record<keyof typeof duesAttendanceEn, string> = {
  'error.billing.annualDuesExists':
    'Acest cont are deja cotizație pentru acest an. Corectați sumele înregistrate prin creditări sau stornări.',
  'billing.annual.title': 'Cotizație anuală',
  'billing.annual.help':
    'Stabiliți cotizația totală pentru acest cont de plătitor și an calendaristic, într-o singură sumă sau în 12 rate lunare. Pentru aceeași cotizație, folosiți fie acest program, fie atribuirile de taxe recurente.',
  'billing.annual.year': 'An',
  'billing.annual.amount': 'Cotizație anuală',
  'billing.annual.credited': 'Creditări și stornări',
  'billing.annual.paid': 'Achitat pentru acest an',
  'billing.annual.remaining': 'Rămas de achitat',
  'billing.annual.installments': 'Program de plată',
  'billing.annual.once': 'O singură cotizație anuală',
  'billing.annual.monthly': '12 rate lunare',
  'billing.annual.dueMonth': 'Luna scadentă (1–12)',
  'billing.annual.preview': 'Previzualizează cotizația anuală',
  'billing.annual.confirm': 'Înregistrează cotizația anuală',
  'billing.annual.confirmHelp':
    'Verificați scadențele și sumele. Înregistrarea creează întreaga obligație anuală, inclusiv ratele viitoare. Corecțiile ulterioare se fac prin creditări sau stornări.',
  'billing.annual.saved': 'Cotizația anuală a fost înregistrată.',
  'billing.annual.empty': 'Nu este stabilită o cotizație anuală pentru acest cont și an.',
  'billing.annual.payments': 'Plăți pentru această cotizație anuală',
  'billing.annual.applied': 'Alocat acestui an',
  'billing.annual.paymentHelp':
    'Înregistrați plățile mai jos și confirmați alocarea lor la sumele datorate. Creditul nealocat nu reduce suma rămasă de achitat până când este alocat.',
  'calendar.history.title': 'Cine a fost prezent sau absent și când',
  'calendar.history.help':
    'Folosiți intervalul calendaristic de mai sus. Prezența efectivă este separată de răspunsul la invitație; prezența neînregistrată nu înseamnă absență. Ciornele și evenimentele anulate sunt excluse.',
  'calendar.history.allAthletes': 'Toți sportivii',
  'calendar.history.allStatuses': 'Toate stările de prezență',
  'calendar.history.status': 'Stare de prezență',
  'calendar.history.show': 'Afișează istoricul prezenței',
  'calendar.history.openEvent': 'Deschide evenimentul și prezența',
  'billing.annualFees.title': 'Cotizații anuale pe echipe',
  'billing.annualFees.description':
    'Stabiliți cotizația anuală pentru fiecare grupă de vârstă și vedeți cât a achitat și cât mai are de achitat fiecare cont.',
  'billing.annualFees.help':
    'Stabiliți o cotizație anuală pentru fiecare grupă de vârstă și an calendaristic. Fiecare cont datorează cotizația fiecărui sportiv de pe el, după echipa în care se află sportivul la începutul anului (sau prima echipă în care a intrat în cursul anului). Toate plățile datate în acel an se scad, fără rambursări, indiferent dacă sunt alocate unei sume datorate. Aici nu se înregistrează nimic.',
  'billing.annualFees.rates': 'Cotizație anuală pe grupă de vârstă',
  'billing.annualFees.notSet': 'Nestabilită',
  'billing.annualFees.save': 'Salvează',
  'billing.annualFees.saved': 'Cotizația anuală a fost salvată.',
  'billing.annualFees.overview': 'Achitat și rămas de achitat',
  'billing.annualFees.team': 'Echipă',
  'billing.annualFees.allTeams': 'Toate echipele',
  'billing.annualFees.noTeam': 'Fără echipă',
  'billing.annualFees.onlyOpen': 'Doar conturile cu sumă rămasă de achitat',
  'billing.annualFees.paid': 'Achitat în acest an',
  'billing.annualFees.overpaid': 'Achitat în plus',
  'billing.annualFees.incomplete':
    'Cotizația este incompletă: un sportiv nu este într-o echipă sau nu există cotizație anuală pentru grupa lui de vârstă.',
  'billing.annualFees.noAthlete': 'Niciun sportiv nu este pe acest cont în acest an.',
  'billing.annualFees.empty': 'Niciun cont nu are sportivi sau plăți în acest an.',
  'billing.annualFees.shown': 'Conturi afișate',
};
